module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-1-1f6ecf8a42e333263f533d6ea473ea18.jpg";